module.exports = __webpack_public_path__ + "img/kx5600-3.e492e363.png";